import { Center, CenterProps, CircularProgress } from '@chakra-ui/react';

export const CenteredCircularProgress = ({ ...props }: CenterProps) => {
   return (
      <Center {...props}>
         <CircularProgress isIndeterminate />
      </Center>
   );
};
